import { AbstractBlock } from './assemblyBlocks/AbstractBlock';
import { Program } from './Program';
import { StateNode } from './state/StateNode';
import { createAssemblyBlock, BlockType } from './factory';

/**
 * Compiles the StateNodes into Program.
 * 
 * @param trees root nodes of trees (precompiled)
 * @returns a Program compiled from the root nodes
 */
export default async function compile(trees: StateNode[]) {

    /**
     * Compiles a single StateNode tree root node into a tree of AssemblyBlocks.
     * Returns a set of all the names of triggers that trigger this tree.
     * 
     * @param node node being compiled
     * @returns a tuple of the corresponding abstract block for this node 
     *    (populated as a tree with children) and the set of trigger names for this tree.
     */
    function compileTree(node: StateNode): [AbstractBlock, Set<string>] {
        console.log("Entering Compile Tree");
        if (node.hasBeenCompiled) throw new EvalError("Looping tree? (In Compiler)");

        node.hasBeenCompiled = true; // flags node as being compiled

        if (node.isInput) {
            console.log("We an input (base case)");
            let compiledNode: AbstractBlock = createAssemblyBlock(node.nodeId, node.blockType, ...node.constInputs);

            let trigSet: Set<string> = new Set();
            if (node.isTriggered) {
                console.log(`${node.constInputs[0]} is this node's trigger`);
                trigSet.add(node.constInputs[0]); //! 0th index is the trigger name
            }

            return [compiledNode, trigSet];
        } else if (node.blockType === BlockType.IF || node.blockType === BlockType.WHILE) {
            console.log("IF BLOCK/ WHILE BLOCK");
            let thisNodeChildren = node.children;
            console.log("Length of children: " + thisNodeChildren.length);
            // let inputs: AbstractBlock[] = [];
            let trigSet: Set<string> = new Set();

            // inputs will be [[condition], [if], [else]]
            let inputs = thisNodeChildren.map(childArr => {
                let compiledArr = childArr.map(child => {
                    console.log('Compiling child');
                    let [compiledChild, trig] = compileTree(child);
                    console.log('Done compiling child');

                    trig.forEach(t => trigSet.add(t));

                    return compiledChild;
                });

                return compiledArr;
            });

            console.log('Done compiling children');
            let compiledNode = createAssemblyBlock(node.nodeId, node.blockType, ...node.constInputs, inputs); //! <---
            console.log('Returning');

            return [compiledNode, trigSet];

        } else {     //todo other cases stuff
            console.log("We not input (recursive)");
            let [thisNodeChildren] = node.children;
            console.log("Length of children: " + thisNodeChildren.length);
            let inputs: AbstractBlock[] = [];
            let trigSet: Set<string> = new Set();

            for (let child of thisNodeChildren) {
                console.log('Compiling child');
                let [compiledChild, trig] = compileTree(child);
                console.log('Done compiling child');

                inputs.push(compiledChild);
                trig.forEach(t => trigSet.add(t));
            }

            if (node.isTriggered) {
                // this can't happen because only inputs are triggered
                // may be deleted later when finalized
                trigSet.add(node.constInputs[0]);
            }

            console.log('Done compiling children');
            let compiledNode = createAssemblyBlock(node.nodeId, node.blockType, ...node.constInputs, inputs); //! <---
            console.log('Returning');

            return [compiledNode, trigSet];
        }

    }

    let subroutines: AbstractBlock[] = Array(trees.length);
    let triggerDict: Map<string, number[]> = new Map();

    console.log('BEGINING COMPILING');
    console.log('We have ' + trees.length + ' trees');

    for (let ix = 0; ix < trees.length; ix++) {
        console.log('COMPILING THIS NODE');
        let [subroutine, trigSet] = compileTree(trees[ix]);
        console.log('DONE COMPILING THIS NODE');
        subroutines[ix] = subroutine;

        console.log(`Trigset:`);
        console.log(trigSet);

        trigSet.forEach(trig => {
            console.log('Trig:' + trig);
            if (triggerDict.has(trig)) {
                triggerDict.get(trig)?.push(ix);
            } else {
                triggerDict.set(trig, [ix]);
            }
        })


    }


    return new Program(subroutines, triggerDict);
}